import { Component, OnInit } from '@angular/core';
import { UserMessagesService } from './user-messages.service';

@Component({
  selector: 'app-user-messages',
  templateUrl: './user-messages.component.html',
  styleUrls: ['./user-messages.component.css']
})
export class UserMessagesComponent implements OnInit {

  errorMessage: string = "";
  errorMessages: string[] = [];
  successMessage:string = "";
  showErrorMessage: boolean = false;
  showSuccessMessage: boolean = false;

  
  constructor(private userMessage: UserMessagesService) { 
    
  }

  
  ngOnInit() {
    this.userMessage.errorMessage$.subscribe(message => 
      {
        this.errorMessage = message;
        this.showErrorMessage = (message) ? true : false;
        window.scroll(0,0);
      });

    this.userMessage.errorMessages$.subscribe(messages =>
      {
        this.errorMessages = messages;
        this.showErrorMessage = (messages.length > 0) ? true : false;
        window.scroll(0,0);
      })

    this.userMessage.successMessage$.subscribe(message => 
      {
        this.successMessage = message;
        this.showSuccessMessage = (message) ? true : false;
        window.scroll(0,0);
      });
  }

}
